import { FC } from "react";
import { useEmitPrepared } from '../hooks/useEmitPrepared';
import { AddSubscriptionProductParameterType, useGetProductFromParent } from '../hooks/useGetProductFromParent';
import { useEmitBtnClicked } from '../hooks/useEmitBtnClicked';
import { useGetOkAddSubscriptionFromParent } from '../hooks/useGetOkAddSubscriptionFromParent';
import { useEmitApiResult } from '../hooks/useEmitApiResult';

const ButtonPrice: FC<{
  productParameter: AddSubscriptionProductParameterType | undefined
}> = ({ productParameter }) => {

  // return <></>

  const normalPrice = productParameter!.price;
  const planPrice = productParameter!.planPrice;

  return !productParameter ? (
    <></>
  ) : normalPrice === planPrice ? (
    <div>{productParameter.price}</div>
  ) : (
    <div>
      <span style={{ textDecoration: "line-through" }}>{ normalPrice }</span>
      &nbsp;&#8594;&nbsp;
      { planPrice }
    </div>
  );
}

export const SubscriptionAddButton: FC<{
  token: string 
}> = ({ token }) => {

  useEmitPrepared();

  // preparedの後に親Windowから送られる商品情報
  const productParameter = useGetProductFromParent(); 

  // "btnClicked"を親にpostMessageする、処理開始のトリガーとなる関数
  const emitBtnClicked = useEmitBtnClicked();

  // "btnClicked"の後に親Windowから送られる、Subscriptionに追加しても良いかの確認フラグ
  const addSubscriptionState = useGetOkAddSubscriptionFromParent(productParameter, token); 

  // addSubscriptionの結果に応じてpostMessageを行う
  useEmitApiResult(productParameter, addSubscriptionState.data);

  return (
    <button
      onClick={emitBtnClicked}
      disabled={addSubscriptionState.loading}
      className={productParameter ? productParameter.btnClassName : ''}
    >
      <div dangerouslySetInnerHTML={{
        __html: productParameter ? productParameter.btnTitle : "",
      }}/>
      <ButtonPrice productParameter={productParameter}/>
    </button>
  );
};
